import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { TallyEntryComponent } from './components/tally-entry/tally-entry.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { LoaderComponent } from './components/loader/loader.component';
import { BookNumberComponent } from './components/book-number/book-number.component';
import { MatChipsModule } from '@angular/material/chips';import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DaybookListComponent } from './components/daybook-list/daybook-list.component';
import { DatePipe } from '@angular/common';
import { AccountsLoginComponent } from './components/accounts-login/accounts-login.component';

import {MatMenuModule} from '@angular/material/menu';
import { CustomDateAdapter } from './models/custom-adapter';
import { CUSTOM_DATE_FORMATS } from './models/custom-date-model';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { PopUpComponent } from './components/pop-up/pop-up.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MappingTransactionsComponent } from './components/mapping-transactions/mapping-transactions.component';
import { DialogBoxComponent } from './components/dialog-box/dialog-box.component';
import { PurposeLedgerMapmasterComponent } from './components/purpose-ledger-mapmaster/purpose-ledger-mapmaster.component';
import { ViewTallyTransactionsComponent } from './components/view-tally-transactions/view-tally-transactions.component';
import { LedgerHeadComponent } from './components/ledger-head/ledger-head.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DisplayDialogComponent } from './components/display-dialog/display-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DashboardUIComponent } from './components/dashboard-ui/dashboard-ui.component';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FinyearMasterComponent } from './components/finyear-master/finyear-master.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { ReceiptVerificationComponent } from './components/receipt-verification/receipt-verification.component';

@NgModule({
  declarations: [
    SidenavComponent,
    TallyEntryComponent,
    LoaderComponent,
    DaybookListComponent,
    BookNumberComponent,
    AccountsLoginComponent,
    PopUpComponent,
    MappingTransactionsComponent,
    DialogBoxComponent,
    PurposeLedgerMapmasterComponent,
    ViewTallyTransactionsComponent,
    LedgerHeadComponent,
    DisplayDialogComponent,
    DashboardUIComponent,
    FinyearMasterComponent,
    UnauthorizedComponent,
    ReceiptVerificationComponent
  ],
  imports: [
    CommonModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 2500,
      closeButton: true,
      progressBar: true,
      preventDuplicates: true,
      newestOnTop: true,
      tapToDismiss: true,
      extendedTimeOut: 1000,
      easing: 'ease-in',
      easeTime: 300,
      progressAnimation: 'increasing',
      toastClass: 'ngx-toastr',
      enableHtml: true
    }),
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatIconModule,
    MatExpansionModule,
    MatCardModule,
    MatTabsModule,
    MatAutocompleteModule,
    DragDropModule,
    MatTooltipModule,
    MatCheckboxModule
  ],
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}}
  ],
  exports: [SidenavComponent]
})
export class AccountsModule { }
